import { render, staticRenderFns } from "./Qianhe.vue?vue&type=template&id=09c8eea7&scoped=true"
import script from "./Qianhe.vue?vue&type=script&lang=js"
export * from "./Qianhe.vue?vue&type=script&lang=js"
import style0 from "./Qianhe.vue?vue&type=style&index=0&id=09c8eea7&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09c8eea7",
  null
  
)

export default component.exports